"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Activity, Cpu, Mic, PhoneCall, Zap } from "lucide-react";
const techSpecs = [{
  id: "resp",
  label: "INTENSITÄT",
  value: "HI-EMT",
  icon: Zap
}, {
  id: "disp",
  label: "FREQUENZ",
  value: "50Hz",
  icon: Activity
}, {
  id: "prec",
  label: "KONTRAKTIONEN",
  value: "12,000+",
  icon: Cpu
}];
export default function VanguardiaTecnologicaIa() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="234756" id="emp-chair" className="bg-background text-foreground py-24 lg:py-32 overflow-hidden relative" ref={sectionRef}>
      <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-[500px] h-[500px] bg-primary/10 rounded-lg blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          <div ref={imageRef} className={`relative transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative rounded-2xl overflow-hidden border border-border/50 bg-secondary/20 aspect-square md:aspect-[4/3] lg:aspect-square flex items-center justify-center group">
              <img src="https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/Bodyconcept_linda_Schlank-im-liegen2.jpg" alt="EMP Chair Technology" className="absolute inset-0 w-full object-cover object-center opacity-90 transition-transform duration-1000 group-hover:scale-110" />
              
              <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" />
            </div>
          </div>

          <div ref={contentRef} className={`space-y-8 transition-all duration-1000 delay-200 ease-out ${contentVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="space-y-4">
              <h2 className="font-default font-bold tracking-tight leading-tight !text-5xl !text-[rgba(168,6,123,1)]">Deine Vorteile auf einen Blick</h2>
              
              <ul className="text-muted-foreground leading-relaxed max-w-xl font-default space-y-4 list-none !text-lg">
                <li className="flex gap-3">
                  <span className="text-primary font-bold">•</span>
                  <span className="!text-xl"><strong>Sofort-Effekt:</strong> Messbare Umfangsreduktion (oft 2-5 cm) bereits nach der ersten Kennenlern-Behandlung.</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-primary font-bold">•</span>
                  <span className="!text-xl"><strong>Hautstraffung:</strong> Cellulite wird sichtbar reduziert, das Bindegewebe wird gefestigt und die Haut wirkt praller.</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-primary font-bold">•</span>
                  <span className="!text-xl !w-[600px]"><strong>Zeitsparend:</strong> Eine Sitzung dauert ca. 45–60 Minuten – so effektiv wie mehrere Stunden intensives Krafttraining.</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-primary font-bold">•</span>
                  <span className="!text-xl"><strong>Völlig schmerzfrei:</strong> Du spürst lediglich ein angenehmes Kribbeln, während du dich auf unserer Komfort-Liege entspannen kannst.</span>
                </li>
              </ul>
            </div>

            <div className="pt-6">
              <Button asChild size="lg" className="bg-primary inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive has-[>svg]:px-4 h-14 px-10 text-base rounded-lg shadow-xl shadow-accent/10 group !bg-[rgba(184,6,127,1)] text-secondary !font-extrabold disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent/90">
                <Link href="https://wa.me/491713617469" target="_blank">
                  Beratungstermin verinbaren!</Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}